import { createSlice } from '@reduxjs/toolkit';

const stored = localStorage.getItem('nm_auth');
const initial = stored ? JSON.parse(stored) : { token: null, user: null, role: null };

const authSlice = createSlice({
  name: 'auth',
  initialState: initial,
  reducers: {
    setAuth(state, action) {
      state.token = action.payload.token;
      state.user = action.payload.user || null;
      state.role = action.payload.role || null;
      localStorage.setItem('nm_auth', JSON.stringify(state));
    },
    setUser(state, action) {
      state.user = action.payload;
      localStorage.setItem('nm_auth', JSON.stringify(state));
    },
    logout(state) {
      state.token = null;
      state.user = null;
      state.role = null;
      localStorage.removeItem('nm_auth');
    },
  },
});

export const { setAuth, setUser, logout } = authSlice.actions;
export default authSlice.reducer;
